<h2 matDialogTitle i18n>Cancel Pickups</h2>
<mat-dialog-content>
  @if ((loading$ | async) || (busy$ | async)) {
    <div class="spinner-container">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  }

  <mat-selection-list #selection (selectionChange)="selectionChange(selection.selectedOptions)" >
    @for (pickup of pickups$ | async; track pickup) {
      <mat-list-option checkboxPosition="before" selected="true" [value]="pickup.id">
        <div mat-line>{{ pickup.reference }} - {{ pickup.courierModule | courierName$ | async }}</div>
        <div mat-line i18n>{{ pickup.date }} ({{ pickup.shipmentIds.length }} shipments)</div>
      </mat-list-option>
    }
  </mat-selection-list>
</mat-dialog-content>
<mat-dialog-actions>
  @if (!(loading$ | async)) {
    <div class="buttons">
      <button mat-button color="primary" (click)="close()" i18n>BACK</button>
      <button mat-button color="primary" (click)="submit()" [disabled]="disableSubmit$ | async" i18n>CANCEL PICKUP</button>
    </div>
  }
</mat-dialog-actions>
